import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AppConfigService } from '../services/app-config.service';
import { LaunchContextService } from '../services/launch-context.service';

// Report-host routes must arrive via a genuine external launch (source/returnUrl/homeUrl),
// not a direct/bookmarked hit - captures context itself since guards run before ShellLayoutComponent mounts.
export const launchContextGuard: CanActivateFn = (_route, state: RouterStateSnapshot) => {
  const appConfigService = inject(AppConfigService);
  const launchContextService = inject(LaunchContextService);
  const router = inject(Router);

  const queryString = state.url.split('?')[1] ?? '';
  launchContextService.captureLaunchContext(new URLSearchParams(queryString));

  // Local dev has no external launcher to arrive from, so skip the direct-access check
  // entirely (same intent as localOnlyMatchGuard on bare /educator).
  if (appConfigService.config.environment === 'local') {
    return true;
  }

  if (launchContextService.hasReturnUrl() || launchContextService.hasHomeUrl()) {
    return true;
  }

  router.navigate(['/educator/unauthorized'], { state: { reason: 'no-launch-context' } });
  return false;
};
